<template>
  <div class="splicing-object-table-row" :class="{lastRow: objectType === 'cable' ? !isOneFiber() && isLastRowOfTube() : false}">
      <table-data-tube
        v-if="objectType === 'cable'"
        :tube-number="tubeNumber"
        :fiber-per-tube-cache="fiberPerTubeCache"
        :tubeColor="tubeColor"
        :is-selected="tubeIsSelected"
        :disabled="disabled"
        @click="$emit('select-tube')"
        @contextmenu="$emit('open-menu-tube', $event)"
      >
        <connection-point-name :name="tubeNumber" :is-selected="tubeIsSelected" />

        <tube-color-icon :icon-color="tubeColor" />
      </table-data-tube>
      <table-data-connection-point
        :is-selected="connectionPointIsSelected"
        :justify-end="true"
        :disabled="disabled"
        :last-tube="objectType === 'cable' ? isLastRowOfTube() : false"
        @click="$emit('select-connection-point')"
        @contextmenu="$emit('open-menu-connection-point', $event)"
        style="padding-right: 0"
      >
        <connection-point-name
          :name="connectionPointName"
          :is-selected="connectionPointIsSelected"
          :number-in-cable="numberInCable"
          side="origin"
        />
        <connection-point-color-icon :icon-color="connectionPointColor" />

        <connection-point-connection-icon :connection-type="connectionType" :state="state" side="origin" />
      </table-data-connection-point>
    </div>
</template>

<script>
import TableDataObject from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataObject";
import TableDataTube from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataTube";
import TubeColorIcon from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TubeColorIcon";
import ConnectionPointName from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointName";
import ConnectionPointColorIcon from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointColorIcon";
import ConnectionPointConnectionIcon from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointConnectionIcon";
import TableDataConnectionPoint from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataConnectionPoint";

export default {
  name: "TableRowOrigin",

  components: {
    TableDataConnectionPoint,
    ConnectionPointConnectionIcon,
    ConnectionPointColorIcon,
    ConnectionPointName,
    TubeColorIcon,
    TableDataTube,
    TableDataObject
  },

  props: {
    objectType: String,

    objectName: String,

    tubeNumber: String,

    connectionPointName: String,

    state: String,

    tubeColor: String,

    connectionPointColor: String,

    tubeIsSelected: Boolean,

    connectionPointIsSelected: Boolean,

    fiberPerTubeCache: Object,

    index: Number,

    tube: Number,
    
    connectionType: String,

    disabled: {
      type: Boolean,
      default: true
    },
    numberInCable: {
      type: Number
    }
  },
  methods:{
    isLastRowOfTube(){
      const tubeFibers = this.fiberPerTubeCache[this.tube];
      const lastFiber = this.tube * tubeFibers;
      return this.index === lastFiber;
    },
    isOneFiber(){
      const tubeFibers = this.fiberPerTubeCache[this.tube];
      return tubeFibers === 1;
    }
  }
};
</script>
<style scoped>
.splicing-object-table-row{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}
.lastRow{
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableRowOrigin.vue